var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "questionProgressBar",
      staticClass: "trbo-a-question-progress-bar",
      style: _vm.styles,
    },
    [
      _c(
        "div",
        {
          staticClass: "trbo-a-question-progress-bar__shadow",
          style: _vm.shadowStyles,
        },
        [
          _c("div", {
            staticClass: "trbo-a-question-progress-bar__shadow__dot",
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "trbo-a-question-progress-bar__items",
          style: _vm.itemsStyles,
        },
        _vm._l(_vm.settings.items, function (item, index) {
          return _c("question-progress-bar-item", {
            key: item.id,
            attrs: {
              "wizard-page": item,
              completed: true,
              current: index === _vm.settings.items.length - 1,
            },
            on: { click: _vm.onItemClick },
          })
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }